module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"notification-bar-wrapper\" ref=\"notificationBarWrapper\">\n    <div class=\"notification-bar negative invisible\">\n        <div class=\"padded-container\" ref=\"html\">\n            <span class=\"icon warning\"></span>\n            <span class=\"notification\">&nbsp;</span>\n            <span title=\"Close\" class=\"icon close\"></span>\n        </div>\n    </div>\n</div>\n")
  }
  return __output;

}